import React from 'react';

const HomeDocente = () => {
    return (
        <div>
            <h1>Home Docente</h1>
        </div>
      );
}
 
export default HomeDocente;